import { ProductByIdResponse } from '@features/products/interfaces/productInterface';
import { Button, Row } from 'antd';
import { useNavigate } from 'react-router-dom';

interface OfferActionsProps {
  product?: ProductByIdResponse;
  actionsOfferBulk: React.ReactNode;
}

export const OfferActions = ({
  product,
  actionsOfferBulk,
}: OfferActionsProps) => {
  const navigate = useNavigate();

  return (
    <Row style={{ gap: '12px' }}>
      {actionsOfferBulk}
      <Button
        type='primary'
        onClick={() => {
          navigate(`/products/${product?.id}/offers/create`);
        }}
        disabled={!product || !product?.active}
      >
        Criar oferta
      </Button>
    </Row>
  );
};
